import { FinancialChart } from './compoenents/financial-chart';
import React, { useMemo } from 'react';
import { HighOverviewReportTypeRes } from '../../../../../api/types/reports/high-overview/high-overview.type';

// Interfaces for data types
interface BranchData {
  name: string;
  actualExpenses: number;
  expectedExpenses: number;
  actualIncome: number;
  expectedIncome: number;
}

export interface HighLevelOverviewBranchesFinancialDetailsDatamodel {
  data: HighOverviewReportTypeRes | undefined;
  onExpensesFilterClick?: () => void;
  onIncomeFilterClick?: () => void;
}

export const HighLevelOverviewBranchesFinancialDetails: React.FC<
  HighLevelOverviewBranchesFinancialDetailsDatamodel
> = ({ data, onExpensesFilterClick, onIncomeFilterClick }) => {
  // Aggregate branch financial data from backend
  const branchData = useMemo(() => {
    if (!data) return [];

    // Create a map to combine income and expense data by branch
    const branchMap = new Map<string, BranchData>();

    // Process income data
    data.branchIncome?.forEach((branchIncome) => {
      const totalActualIncome = branchIncome.programs.reduce(
        (sum, program) => sum + (program.actualIncome || 0),
        0,
      );
      const totalExpectedIncome = branchIncome.programs.reduce(
        (sum, program) => sum + (program.expectedIncome || 0),
        0,
      );

      branchMap.set(branchIncome.branchName, {
        name: branchIncome.branchName,
        actualIncome: totalActualIncome,
        expectedIncome: totalExpectedIncome,
        actualExpenses: 0,
        expectedExpenses: 0,
      });
    });

    // Process expense data
    data.branchExpense?.forEach((branchExpense) => {
      const totalActualExpense = branchExpense.programs.reduce(
        (sum, program) => sum + (program.actualExpense || 0),
        0,
      );
      const totalExpectedExpense = branchExpense.programs.reduce(
        (sum, program) => sum + (program.expectedExpense || 0),
        0,
      );

      const existingBranch = branchMap.get(branchExpense.branchName);
      if (existingBranch) {
        existingBranch.actualExpenses = totalActualExpense;
        existingBranch.expectedExpenses = totalExpectedExpense;
      } else {
        branchMap.set(branchExpense.branchName, {
          name: branchExpense.branchName,
          actualIncome: 0,
          expectedIncome: 0,
          actualExpenses: totalActualExpense,
          expectedExpenses: totalExpectedExpense,
        });
      }
    });

    return Array.from(branchMap.values());
  }, [data]);

  return (
    <div style={{ marginTop: '16px' }} className="charts-row">
      {/* Expenses Chart */}
      <FinancialChart
        data={branchData.map((branch) => ({
          name: branch.name,
          actualValue: branch.actualExpenses,
          expectedValue: branch.expectedExpenses,
        }))}
        title="הוצאות הוראה"
        actualLabel="הוצאות בפועל"
        expectedLabel="הוצאות צפויות"
        actualColor="#3b82f6"
        expectedColor="#93c5fd"
        onFilterClick={onExpensesFilterClick}
      />

      {/* Income Chart */}
      <FinancialChart
        data={branchData.map((branch) => ({
          name: branch.name,
          actualValue: branch.actualIncome,
          expectedValue: branch.expectedIncome,
        }))}
        title="הכנסות מסטודנטים"
        actualLabel="הכנסות בפועל"
        expectedLabel="הכנסות צפויות"
        actualColor="#10b981"
        expectedColor="#6ee7b7"
        onFilterClick={onIncomeFilterClick}
      />
    </div>
  );
};
